import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  totalProducts:0,
  productType:[],
  loading: false,
};

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    
    setProducts: (state, action) => {
      state.items = [...state.items, ...action.payload]; 
      state.loading = false;
    },
    setTotalProducts:(state,action)=>{
      state.totalProducts=action.payload
    },
    setProductType:(state,action)=>{
      state.productType=action.payload
    },
    clearProducts: (state) => {
      state.items = []; 
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setProducts, setLoading, setTotalProducts, setProductType, clearProducts } = productSlice.actions;

export default productSlice.reducer;
